// apiRoutes.ts
export const API_ROUTES = {
  AUTH: {
    LOGIN: "/user/login",
    DETAILS: "/user/decode-token",
    FORGOT_PASSWORD: "/user/forgot-password",
    RESET_PASSWORD: (id) => `/user/reset-password/${id}`,
  },
  USER: {
    LIST: "/user/list",
    CREATE: "/user/add",
    EDIT: (id) => `/user/update/${id}`,
    DELETE: (id) => `user/delete/${id}`,
    ROLE: "/role/list",
    MEDIA: "/media/upload",
  },
  ORDER: {
    LIST: "/order/list",
    CREATE: "/order/add-order-or-item",
    EDIT: (id) => `/order/edit/${id}`,
    DELETE: (id) => `order/delete/${id}`,
    EDIT_ITEM: (id) => `/order/edit-item/${id}`,
    STATUS: "/master/order-status-list",
    INFO: "order/getInfo",
    DELETE_ITEM: (id) => `order/delete-item/${id}`,
    CHANGE_STATUS: (id) => `/order/edit/${id}`,
    SPLIT_ITEM: "/order/split-item",
    REVERSE_SPLIT_ITEM: "/order/reverse-split",
  },
  CONTAINER: {
    LIST: "/container/list",
    GENERATOR_NO: "/container/no-generator",
    CREATE: "/container/add",
    ADDITEM: "/container/add-item",
    EDIT: `/container/edit`,
    DELETE: (id) => `container/delete/${id}`,
    INFO: "container/getInfo",
    STATUS: "/master/container-status-list",
    ORDER_ITEMS_LIST: "/order/list-item",
    DELETE_ITEM: (id) => `container/delete-item/${id}`,
    ASSIGN_ITEM: "/container/assign-item",
    UNASSIGN_ITEM: "/container/unassign-item",
    SPLIT_ITEM: "/container/split-item",
    REVERSE_SPLIT_ITEM: "/container/reverse-split",
  },
  ANNOUNCEMENT: {
    LIST: "/headerMessage/list",
    CREATE: "/headerMessage/add",
    EDIT: (id) => `/headerMessage/edit/${id}`,
    DELETE: (id) => `/headerMessage/delete/${id}`,
  },
  NOTES: {
    LIST: "/notes/list",
    CREATE: "/notes/add",
  },
  DASHBOARD: {
    LIST: "/dashboard/details",
  },
};
